import React from "react";
import ReactDOM from "react-dom";

import EditableTable from "../../components/tables/EditableTable";
import Header from "../../components/Header";
import MainCheckBoxInput from "../../components/inputs/MainCheckBoxInput";
import MainImageUpload from "../../components/inputs/MainImageUpload";
import MainLabel from "../../components/inputs/MainLabel";
import MainSelectInput from "../../components/inputs/MainSelectInput";
import MainTabButton from "../../components/inputs/MainTabButton";
import MainTextField from "../../components/inputs/MainTextField";
import SnackbarAlert from "../../components/alerts/SnackbarAlert";
import UserLocalSalePopup from "./opoups/UserLocalSalePopup";
import UserRepresentedPopup from "./opoups/UserRepresentedPopup";
import UserSalesRegionPopup from "./opoups/UserSalesRegionPopup";

import LoadingGif from "../../components/visual/LoadingGif";

import { addLastAccess, changeActiveTabStyle } from "../../utils/layout";
import { Box, Button, Grid } from "@mui/material";
import { createEditTab } from "../../utils/layout";
import { defaultRequest, optionsRequest } from "../../utils/request/request";
import { handleChangeImage, handleChangeText } from "../../utils/handleChange";


class User extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: true,
            isLoadingTab: true,
            isLoadingUserTable: true,
            isLoadingUserSeller: true,

            isLoadingUserLocalSaleTable: true,
            isLoadingUserSalesRegionTable: true,
            isLoadingUserRepresentativeRegionsTable: true,
            isLoadingUserRepresentativeLocalTable: true,
            isLoadingUserRepresentative: true,

            isUserLocalSalePopupOpen: false,
            isUserSalesRegionPopupOpen: false,
            isUserRepresentedPopupOpen: false,

            menuId: '37',

            // filtros
            name: null,
            email: null,
            type: null,
            status: null,
            function: null,
            team: null,
            superior: null,

            isANewUser: false,

            userList: [],
            userColumns: {},
            userTotalSize: '',

            userLocalSaleList: [],
            userLocalSaleColumns: [
                ['cnpj', 'CNPJ'],
                ['fantasia', 'Fantasia'],
                ['coderp', 'Código'],
            ],
            userLocalSaleTotalSize: '',

            userSalesRegionList: [],
            userSalesRegionColumns: [
                ['idregiao', 'ID'],
                ['desregiao', 'Região de Vendas'],
            ],
            userSalesRegionTotalSize: '',

            representativeRegionList: [],
            representativeRegionColumns: [
                ['desregiao', 'Nome da Região'],
                ['situacao', 'Situação'],
            ],
            representativeRegionTotalSize: '',

            representativeLocalList: [],
            representativeLocalColumns: [
                ['cnpj', 'CNPJ'],
                ['razao', 'Razão'],
                ['localpadrao', 'Local Padrão'],
            ],
            representativeLocalTotalSize: '',

            // objeto do usuario
            userObject: {
                idusuario: null,
                email: null,
                tipousuario: null,
                nome: null,
                sobrenome: null,
                telcelular: null,
                situacao: null,
                classecomercial: null,
                idlocal: null,
                foto: null,
                cpfcnpj: null,
                coderp: null,
                idusuariopai: null,
                idorganograma: null,
            },
            // objeto VENDEDOR
            sellerObject: {
                idequipe: null,
                idpolcomissao: null,
                idsalesregion: null,
                idlinha: null,
            },
            // objeto REPRESENTANTE
            representativeObject: {
                idrepresentada: {
                    idrepresentada: ''
                },
                pedidos: '',
                preco: ''
            },

            superiorOptions: [],
            saleTeamOptions: [],
            userTypeOptions: [],
            localSaleOptions: [],
            productLineOptions: [],
            representedOptions: [],
            salesRegionOptions: [],
            userFunctionOptions: [],
            comissionPolicyOptions: [],
            userNameSurnameOptions: [],
            userComercialClassOptions: [],
            statusOptions: [
                { 'value': 'A', 'label': 'Ativo' },
                { 'value': 'X', 'label': 'Cancelado' },
                { 'value': 'B', 'label': 'Bloqueado' },
            ],
            localpadraoOptions: [
                { 'value': 'S', 'label': 'Sim' },
                { 'value': 'N', 'label': 'Não' },
            ],

            tabs: [
                { id: 'data', title: 'Cadastro de usuário' },
            ],
        }
    }

    componentDidMount() {
        addLastAccess(this.state.menuId)
        this.onUserTableChange(0)
        optionsRequest(this, ['comissionPolicy', 'localSale', 'productLine', 'represented', 'saleTeam', 'salesRegion', 'userComercialClass', 'userFunction', 'userNameSurname', 'userType'])
    }

    closeEditTab = () => {
        var element = document.getElementById('edit-tab')
        element.parentNode.removeChild(element)
        this.onCloseEditTab()
    }

    createEditTab = (params, isRegister = false) => {
        if (isRegister) {
            this.setState({
                selectedRow: params,
                isLoadingTab: true,
                isLoadingUserSeller: true,
                isLoadingUserLocalSaleTable: true,
                isLoadingUserSalesRegionTable: true,
                isLoadingUserRepresentativeRegionsTable: true,
                isLoadingUserRepresentativeLocalTable: true,
                isLoadingUserRepresentative: true,
                isUserLocalSalePopupOpen: false,
                isUserSalesRegionPopupOpen: false,
                isUserRepresentedPopupOpen: false,
                activeTab: 'data',
                userObject: {
                    idusuario: null,
                    email: null,
                    nome: null,
                    sobrenome: null,
                    telcelular: null,
                    situacao: null,
                    classecomercial: null,
                    idlocal: null,
                    foto: null,
                    cpfcnpj: null,
                    coderp: null,
                    idusuariopai: null,
                    idorganograma: null, //funcao
                    tipousuario: {
                        idtipousuario: null
                    }
                },
                sellerObject: {
                    idequipe: null,
                    idpolcomissao: null,
                    idsalesregion: null,
                    idlinha: null,
                },
                representativeObject: {
                    idrepresentada: {
                        idrepresentada: ''
                    },
                    pedidos: '',
                    preco: ''
                },
            }, () => createEditTab('Cadastrar Novo Usuário', this.state.tabs, this.props, this.handleChangeTab, this.onCloseEditTab))
        } else {
            this.setState({
                isANewUser: false,
                selectedRow: params,
                activeTab: 'data',
            }, () => createEditTab('Editar Usuário', this.state.tabs, this.props, this.handleChangeTab, this.onCloseEditTab))
        }
    }

    deleteUserLocalSale = (id) => {
        let config = {
            method: 'delete',
            endpoint: 'user/single/localsale'
        }
        let form = {
            id: this.state.selectedRow.idusuario,
            localsaleId: id
        }
        defaultRequest(config, form).then((r) => {
            if (r.status) {
                this.setState({
                    alertMessage: r.data.message,
                    alertType: 'success',
                    showAlert: true,
                }, () => this.onUserLocalSaleTableChange(0))
            } else {
                this.setState({
                    alertMessage: r.data.message,
                    alertType: 'error',
                    showAlert: true
                })
            }
        })
    }

    deleteUserSalesRegion = (id) => {
        let config = {
            method: 'delete',
            endpoint: 'user/single/salesregion'
        }
        let form = {
            id: this.state.selectedRow.idusuario,
            salesregionId: id
        }
        defaultRequest(config, form).then((r) => {
            if (r.status) {
                this.setState({
                    alertMessage: r.data.message,
                    alertType: 'success',
                    showAlert: true,
                }, () => this.onUserSalesRegionTableChange(0))
            } else {
                this.setState({
                    alertMessage: r.data.message,
                    alertType: 'error',
                    showAlert: true
                })
            }
        })
    }

    fetchSingleUser = async () => {
        if (this.state.isFetchingUser) return
        this.setState({ isFetchingUser: true })

        try {
            const results = await Promise.allSettled([
                this.searchSingleUser(),
                this.searchSingleUserSuperior(),
                this.onUserLocalSaleTableChange(0),
                this.onUserSalesRegionTableChange(0),
            ])

            results.forEach(result => {
                if (result.status === 'rejected') {
                    console.error('Erro na requisição:', result.reason)
                }
            })

            this.setState({
                isLoadingTab: false,
                isLoadingUserLocalSaleTable: false,
            }, () =>
                this.state.userObject.tipousuario === 1 ? this.searchSingleUserSeller()
                    : this.state.userObject.tipousuario === 6 ? this.searchSingleUserRepresentative()
                        : null
            )

        } catch (error) {
            console.error('Erro no processo de fetchSingleUser', error)
            this.setState({
                isLoadingTab: false,
                isLoadingUserLocalSaleTable: false,
            }, () => this.handleChangeTab())
        } finally {
            this.setState({ isFetchingUser: false }, () => this.handleChangeTab())
        }
    }

    handleChangeImage = (hexString, fieldName) => {
        handleChangeImage(this, this.state.userObject, hexString, fieldName, () => this.handleChangeTab())
    }

    handleChangeTab = (event) => {
        if (this.state.isLoadingTab && !this.state.isANewUser) {
            ReactDOM.render(<LoadingGif />, document.getElementById('inside-edit-box'), () => this.fetchSingleUser())
            return
        }

        if (!this.state.userObject && !this.state.isANewUser) {
            return
        }
        var page = event?.target.id ? event?.target.id : this.state.activeTab ?? this.state.tabs[0]['id']
        changeActiveTabStyle(this.state.tabs, page, this.props.colors)

        var context = ''
        if (page === 'data') {
            context =
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container columnSpacing={1} rowSpacing={2} sx={{ flexDirection: { xs: 'column', sm: 'column', md: 'row' }, margin: '15px 0' }}>
                        <Grid item md={12} sx={{ width: '100%' }}>
                            <Box
                                width='99%'
                                border='1px solid'
                                borderRadius='5px'
                                padding='0 10px 10px 5px'
                                marginBottom='15px'
                                borderColor={this.props.colors.grey[1100]}
                                boxShadow={`3px 3px 3px ${this.props.colors.custom['boxShadow']}`}
                            >
                                <Grid container columnSpacing={1} rowSpacing={2} sx={{ flexDirection: { xs: 'column', sm: 'column', md: 'row' }, margin: '10px 0' }}>

                                    <Grid item md={9}>
                                        <Grid container columnSpacing={1} rowSpacing={2}>
                                            <Grid item md={2}><MainTextField {...this.props} type='number' id='usuarioerp' value={this.state.userObject.usuarioerp} label='Usuário ERP' handleChange={this.handleChangeTextTabUserObject} /></Grid>
                                            <Grid item md={5}><MainTextField required {...this.props} id='nome' value={this.state.userObject.nome} label='Nome' handleChange={this.handleChangeTextTabUserObject} fullWidth /></Grid>
                                            <Grid item md={5}><MainTextField required {...this.props} id='sobrenome' value={this.state.userObject.sobrenome} label='Sobrenome' handleChange={this.handleChangeTextTabUserObject} width='100%' /></Grid>

                                            <Grid item md={9}><MainTextField required {...this.props} id='email' value={this.state.userObject.email} label='Email' handleChange={this.handleChangeTextTabUserObject} width='98%' /></Grid>
                                            <Grid item md={3}><MainTextField required {...this.props} id='senha' value={this.state.userObject.senha} label='Senha' handleChange={this.handleChangeTextTabUserObject} width='99%' /></Grid>

                                            <Grid item md={3}><MainTextField required {...this.props} id='telcelular' value={this.state.userObject.telcelular} label='Telefone/WhatsApp' handleChange={this.handleChangeTextTabUserObject} /></Grid>
                                            <Grid item md={3}><MainTextField {...this.props} id='cpfcnpj' value={this.state.userObject.cpfcnpj} label='CPF/CNPJ' handleChange={this.handleChangeTextTabUserObject} /></Grid>
                                            <Grid item md={3}><MainSelectInput required {...this.props} id='situacao' value={this.state.userObject.situacao} label='Situação' optionsList={this.state.statusOptions} handleChange={this.handleChangeTextTabUserObject} /></Grid>
                                            <Grid item md={3}>
                                                <Box
                                                    sx={{
                                                        mr: '45px',
                                                        display: 'grid',
                                                        gridTemplateColumns: '1% 49% 50%',
                                                        width: '100%',
                                                        border: '1px solid',
                                                        borderRadius: '5px',
                                                        paddingLeft: '5px',
                                                        borderColor: this.props.colors.grey[1100]
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            position: 'relative',
                                                            display: 'inline-block',
                                                            width: '100%',
                                                        }}
                                                    >
                                                        {/* Título embutido na borda */}
                                                        <Box
                                                            sx={{
                                                                display: 'inline-block',
                                                                padding: '0 5px',
                                                                backgroundColor: 'white',
                                                                fontSize: '13px',
                                                                color: this.props.colors.grey[1100],
                                                                position: 'relative',
                                                                top: '-12px',
                                                                left: '10px'
                                                            }}
                                                        >
                                                            Acessos
                                                        </Box>
                                                    </Box>
                                                    <MainCheckBoxInput {...this.props} id='usarbackoffice' value={this.state.userObject.usarbackoffice} label='BackOffice' handleChange={this.handleChangeTextTabUserObject} fontSize='10px' />
                                                    <MainCheckBoxInput {...this.props} id='usarorcamento' value={this.state.userObject.usarorcamento} label='Orçamento' handleChange={this.handleChangeTextTabUserObject} fontSize='10px' />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item md={3}>
                                        <MainImageUpload {...this.props} id='foto' src={this.state.userObject.foto} handleChangeImage={this.handleChangeImage} handleChangeTab={this.handleChangeTab} maxHeight='160px' isb64 />
                                    </Grid>

                                    <Grid item md={3}><MainSelectInput {...this.props} id='classecomercial' value={this.state.userObject.classecomercial} optionsList={this.state.userComercialClassOptions} label='Classe Comercial' handleChange={this.handleChangeTextTabUserObject} width='100%' /></Grid>
                                    <Grid item md={7}><MainSelectInput required {...this.props} id='idlocal' value={this.state.userObject.idlocal} optionsList={this.state.localSaleOptions} label='Local de Venda Padrão' handleChange={this.handleChangeTextTabUserObject} width='100%' /></Grid>
                                    <Grid item md={2}><Button sx={{ background: this.props.colors.custom['searchButtons'], width: '94%', height: '100%' }} {...this.props} variant='contained' onClick={() => this.setState({ isUserLocalSalePopupOpen: true }, () => this.handleChangeTab())} disabled={!this.state.userObject.idusuario ? true : false}>Locais de Venda</Button></Grid>

                                    {this.state.isUserLocalSalePopupOpen && (
                                        <UserLocalSalePopup
                                            {...this.props}
                                            {...this.state}
                                            isOpen={this.state.isUserLocalSalePopupOpen}
                                            closePopup={() => this.setState({ isUserLocalSalePopupOpen: false }, () => this.handleChangeTab())}
                                            handleChangeText={this.handleChangeText}
                                            includeUserLocalSale={this.includeUserLocalSale}
                                            onUserLocalSaleTableChange={this.onUserLocalSaleTableChange}
                                            onUserLocalSaleTableEdit={this.onUserLocalSaleTableEdit}
                                        />
                                    )}

                                    <Grid item md={3}><MainSelectInput {...this.props} id='tipousuario' value={this.state.userObject.tipousuario} optionsList={this.state.userTypeOptions} label='Tipo de Usuário' handleChange={this.handleChangeTextTabUserObject} width='100%' /></Grid>
                                    <Grid item md={3}><MainSelectInput {...this.props} id='idorganograma' value={this.state.userObject.idorganograma} optionsList={this.state.userFunctionOptions} label='Função' handleChange={this.handleChangeTextTabUserObject} width='100%' disabled={this.state.isANewUser} /></Grid>
                                    <Grid item md={6}><MainSelectInput {...this.props} id='idusuariopai' value={this.state.userObject.idusuariopai} optionsList={this.state.superiorOptions} label='Superior' handleChange={this.handleChangeTextTabUserObject} width='98%' disabled={this.state.isANewUser} /></Grid>

                                    {this.state.userObject.tipousuario && this.state.userObject.tipousuario === 1 ?
                                        this.state.isLoadingUserSeller ? (
                                            <LoadingGif />
                                        ) : (

                                            <Grid item md={12}>
                                                <Box sx={{ width: '99%', padding: '10px 10px', border: `1px solid ${this.props.colors.grey[800]}`, borderRadius: '5px' }}>
                                                    <Grid container columnSpacing={1} rowSpacing={2} sx={{ flexDirection: { xs: 'column', sm: 'column', md: 'row' } }}>
                                                        <Grid item md={2}><MainTextField required {...this.props} type='number' id='coderp' value={this.state.userObject.coderp} label='Código ERP' handleChange={this.handleChangeTextTabUserObject} /></Grid>
                                                        <Grid item md={4}><MainSelectInput {...this.props} id='idequipe' value={this.state.sellerObject.idequipe} optionsList={this.state.saleTeamOptions} label='Equipe' handleChange={this.handleChangeTextTabSellerObject} width='100%' /></Grid>
                                                        <Grid item md={4}><MainSelectInput {...this.props} id='idpolcomissao' value={this.state.sellerObject.idpolcomissao} optionsList={this.state.comissionPolicyOptions} label='Política de Comissão' handleChange={this.handleChangeTextTabSellerObject} width='100%' /></Grid>
                                                        <Grid item md={2}><Button {...this.props} variant='contained' onClick={this.verifyComissionPolicePopup} sx={{ background: this.props.colors.custom['searchButtons'], width: '94%', height: '100%' }}>Visualizar Política</Button></Grid>

                                                        {this.state.isUserSalesRegionPopupOpen && (
                                                            <UserSalesRegionPopup
                                                                {...this.props}
                                                                {...this.state}
                                                                isOpen={this.state.isUserSalesRegionPopupOpen}
                                                                closePopup={() => this.setState({ isUserSalesRegionPopupOpen: false }, () => this.handleChangeTab())}
                                                                handleChangeText={this.handleChangeText}
                                                                handleChangeTab={this.handleChangeTab}
                                                                showAlert={this.showAlert}
                                                                comissionPolicyId={this.state.sellerObject.idpolcomissao}
                                                            />
                                                        )}

                                                        <Grid item md={4}><MainSelectInput {...this.props} id='idsalesregion' value={this.state.sellerObject.idsalesregion} optionsList={this.state.salesRegionOptions} label='Regiões de vendas' handleChange={this.handleChangeTextTabSellerObject} width='100%' /></Grid>
                                                        <Grid item md={2}>
                                                            <MainTabButton {...this.props} onButtonClick={this.includeUserSalesRegion} title="Inserir" disabled={!this.state.userObject.idusuario ? true : false} sx={{ width: { xs: '100%', sm: '100%', md: '95%' } }} />
                                                        </Grid>

                                                        <Grid item md={4}><MainSelectInput {...this.props} id='idlinha' value={this.state.sellerObject.idlinha} optionsList={this.state.productLineOptions} label='Linha' handleChange={this.handleChangeTextTabSellerObject} width='100%' /></Grid>

                                                        <Grid item md={6}>
                                                            <EditableTable
                                                                {...this.props}
                                                                height='30vh'
                                                                customMargin='10px 0 0 0'
                                                                allowEdit
                                                                noEditButton
                                                                id='idregiao'
                                                                data={this.state.userSalesRegionList}
                                                                columns={this.state.userSalesRegionColumns}
                                                                rowId='idregiao'
                                                                totalSize={this.state.userSalesRegionTotalSize}
                                                                onPageChange={this.onUserSalesRegionTableChange}
                                                                onEditRow={this.onUserSalesRegionTableEdit}
                                                                onRowDoubleClick={() => { }}
                                                                isLoading={this.state.isLoadingUserSalesRegionTable}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </Grid>
                                        )
                                        : this.state.userObject.tipousuario && this.state.userObject.tipousuario === 6 ?
                                            this.state.isLoadingUserRepresentative ? (
                                                <LoadingGif />
                                            ) : (
                                                <Grid item md={12}>
                                                    <Box sx={{ width: '99%', padding: '10px 10px', border: `1px solid ${this.props.colors.grey[800]}`, borderRadius: '5px' }}>
                                                        <Grid container columnSpacing={1} rowSpacing={2} sx={{ flexDirection: { xs: 'column', sm: 'column', md: 'row' } }}>
                                                            <Grid item md={2}><MainTextField required {...this.props} type='number' id='coderp' value={this.state.userObject.coderp} label='Código ERP' handleChange={this.handleChangeTextTabUserObject} /></Grid>
                                                            <Grid item md={7}><MainSelectInput required {...this.props} id='idrepresentada.idrepresentada' value={this.state.representativeObject.idrepresentada.idrepresentada} optionsList={this.state.representedOptions} label='Representada' handleChange={this.handleChangeTextTabRepresentativeObject} width='100%' /></Grid>
                                                            <Grid item md={3}><Button sx={{ background: this.props.colors.custom['searchButtons'], width: '94%', height: '100%' }} {...this.props} variant='contained' onClick={() => this.setState({ isUserRepresentedPopupOpen: true }, () => this.handleChangeTab())}>Cadastrar Representada</Button></Grid>

                                                            <Grid item md={4}><MainTextField {...this.props} id='' value={''} label='Linha de Produto' disabled={true} /></Grid>
                                                            <Grid item md={4}><MainCheckBoxInput {...this.props} id='pedidos' value={this.state.representativeObject.pedidos} label='Visualizar todos os pedidos da representada' handleChange={this.handleChangeTextTabRepresentativeObject} /></Grid>
                                                            <Grid item md={4}><MainCheckBoxInput {...this.props} id='preco' value={this.state.representativeObject.preco} label='Gera tabela de preços' handleChange={this.handleChangeTextTabRepresentativeObject} /></Grid>

                                                            <Grid item md={5}>
                                                                <EditableTable
                                                                    {...this.props}
                                                                    height='25vh'
                                                                    customMargin='10px 0 0 0'
                                                                    id='idregiao'
                                                                    data={this.state.representativeRegionList}
                                                                    columns={this.state.representativeRegionColumns}
                                                                    rowId='idregiao'
                                                                    totalSize={this.state.representativeRegionTotalSize}
                                                                    onPageChange={() => { }}
                                                                    onEditRow={() => { }}
                                                                    onRowDoubleClick={() => { }}
                                                                    isLoading={this.state.isLoadingUserRepresentativeRegionsTable}
                                                                />
                                                            </Grid>

                                                            <Grid item md={7}>
                                                                <EditableTable
                                                                    {...this.props}
                                                                    height='25vh'
                                                                    customMargin='10px 0 0 0'
                                                                    id='idlocalvenda'
                                                                    data={this.state.representativeLocalList}
                                                                    columns={this.state.representativeLocalColumns}
                                                                    rowId='idlocalvenda'
                                                                    totalSize={this.state.representativeLocalTotalSize}
                                                                    onPageChange={() => { }}
                                                                    onEditRow={this.onUserRepresentativeLocalTableEdit}
                                                                    onRowDoubleClick={() => { }}
                                                                    isLoading={this.state.isLoadingUserRepresentativeLocalTable}
                                                                    extraColumnsConfig={
                                                                        {
                                                                            'localpadrao': {
                                                                                'type': 'select',
                                                                                'options': this.state.localpadraoOptions
                                                                            },
                                                                        }
                                                                    }
                                                                />
                                                            </Grid>

                                                        </Grid>
                                                    </Box>
                                                </Grid>
                                            )
                                            : this.state.userObject.tipousuario && this.state.userObject.tipousuario === 7 ?
                                                <>
                                                    <Grid item md={12}>
                                                        <Box sx={{ width: '99%', padding: '10px 10px', border: `1px solid ${this.props.colors.grey[800]}`, borderRadius: '5px' }}>
                                                            <Grid container columnSpacing={1} rowSpacing={2} sx={{ flexDirection: { xs: 'column', sm: 'column', md: 'row' } }}>
                                                                <Grid item md={2}><MainTextField required {...this.props} type='number' id='coderp' value={this.state.userObject.coderp} label='Código ERP' handleChange={this.handleChangeTextTabSellerObject} disabled={true} /></Grid>
                                                                <Grid item md={7}><MainSelectInput required {...this.props} id='idrepresentada' value={this.state.userObject.idrepresentada} optionsList={this.state.representedOptions} label='Representada' handleChange={this.handleChangeTextTabUserObject} width='100%' /></Grid>
                                                                <Grid item md={3}><Button sx={{ background: this.props.colors.custom['searchButtons'], width: '94%', height: '100%' }} {...this.props} variant='contained' onClick={() => this.setState({ isUserRepresentedPopupOpen: true }, () => this.handleChangeTab())}>Cadastrar Representada</Button></Grid>
                                                            </Grid>
                                                        </Box>
                                                    </Grid>
                                                </>
                                                :
                                                <></>
                                    }

                                    {this.state.isUserRepresentedPopupOpen && (
                                        <UserRepresentedPopup
                                            {...this.props}
                                            {...this.state}
                                            isOpen={this.state.isUserRepresentedPopupOpen}
                                            closePopup={() =>
                                                !this.state.isANewUser
                                                    ? this.setState({ isUserRepresentedPopupOpen: false, isLoadingUserRepresentative: true }, () => { this.handleChangeTab(); this.searchSingleUserRepresentative() })
                                                    : this.setState({ isUserRepresentedPopupOpen: false, isLoadingUserRepresentative: false }, () => { this.handleChangeTab() })}
                                            handleChangeText={this.handleChangeText}
                                            handleChangeTab={this.handleChangeTab}
                                            showAlert={this.showAlert}
                                        />
                                    )}

                                    <Grid item md={10}></Grid>
                                    <Grid item md={2}><Button sx={{ background: this.props.colors.custom['searchButtons'], width: '94%', height: '100%' }} {...this.props} variant='contained' onClick={this.saveUser}>Salvar</Button></Grid>

                                </Grid>
                            </Box>
                        </Grid >
                    </Grid >
                </Box >
        }
        ReactDOM.render(context, document.getElementById('inside-edit-box'), () => this.setState({ activeTab: page }))
    }

    handleChangeText = (event) => {
        this.setState({
            [event.target.id]: event.target.value,
        }, () => !this.state.isLoadingTab ? this.handleChangeTab() : null)
    }

    handleChangeTextTabUserObject = (event) => {
        handleChangeText(this.state.userObject, event.target.id, event.target.value, () => {
            if (event.target.id === 'tipousuario') {
                this.setState({
                    isLoadingUserRepresentative: true,
                    isLoadingUserSeller: true,
                    isUserRepresentativeLoaded: event.target.value !== 6
                })
                if (event.target.value === 6) {
                    if (!this.state.isANewUser) {
                        this.searchSingleUserRepresentative()
                    } else {
                        this.setState({ isLoadingUserRepresentative: false, isLoadingUserRepresentativeRegionsTable: false, isLoadingUserRepresentativeLocalTable: false }, () => this.handleChangeTab())
                    }
                }
                else if (event.target.value === 1) {
                    if (!this.state.isANewUser) {
                        this.searchSingleUserSeller()
                    } else {
                        this.setState({ isLoadingUserSeller: false, isLoadingUserSalesRegionTable: false }, () => this.handleChangeTab())
                    }
                }
            }
            this.handleChangeTab()
        })
    }

    handleChangeTextTabSellerObject = (event) => {
        handleChangeText(this.state.sellerObject, event.target.id, event.target.value, () => this.handleChangeTab())
    }

    handleChangeTextTabRepresentativeObject = (event) => {
        handleChangeText(this.state.representativeObject, event.target.id, event.target.value, () => this.handleChangeTab())
    }

    includeUserLocalSale = () => {
        if (!this.state.newLocalsale) {
            this.setState({
                alertMessage: 'Necessário selecionar um Local de Venda.',
                alertType: 'error',
                showAlert: true
            })
            return
        }

        let config = {
            method: 'post',
            endpoint: 'user/single/localsale'
        }
        let form = {
            id: this.state.selectedRow.idusuario,
            localsaleId: this.state.newLocalsale,
        }
        defaultRequest(config, form).then((r) => {
            if (r.status) {
                this.setState({
                    alertMessage: r.data.message,
                    alertType: 'success',
                    showAlert: true,

                    newLocalsale: '',
                }, () => this.onUserLocalSaleTableChange(0))
            } else {
                this.setState({
                    alertMessage: r.data.message,
                    alertType: 'error',
                    showAlert: true
                })
            }
        })
    }

    includeUserSalesRegion = () => {
        if (!this.state.sellerObject.idsalesregion) {
            this.setState({
                alertMessage: 'Necessário selecionar uma Região de Venda.',
                alertType: 'error',
                showAlert: true
            })
            return
        }

        let config = {
            method: 'post',
            endpoint: 'user/single/salesregion'
        }
        let form = {
            id: this.state.selectedRow.idusuario,
            salesregionId: this.state.sellerObject.idsalesregion,
        }
        defaultRequest(config, form).then((r) => {
            if (r.status) {
                this.setState({
                    alertMessage: r.data.message,
                    alertType: 'success',
                    showAlert: true,

                    sellerObject: { idsalesregion: '' }
                }, () => this.onUserSalesRegionTableChange(0))
            } else {
                this.setState({
                    alertMessage: r.data.message,
                    alertType: 'error',
                    showAlert: true
                })
            }
        })
    }

    onCloseEditTab = () => {
        this.setState({
            isLoadingTab: true,
            isLoadingUserSeller: true,
            isLoadingUserLocalSaleTable: true,
            isLoadingUserSalesRegionTable: true,
            isLoadingUserRepresentativeRegionsTable: true,
            isLoadingUserRepresentativeLocalTable: true,
            isLoadingUserRepresentative: true,
            isUserLocalSalePopupOpen: false,
            isUserSalesRegionPopupOpen: false,
            isUserRepresentedPopupOpen: false,
            representativeLocalList: [],
            representativeRegionList: [],
            isANewUser: false,
            activeTab: 'data',
            userObject: {
                idusuario: null,
                email: null,
                tipousuario: null,
                nome: null,
                sobrenome: null,
                telcelular: null,
                situacao: null,
                classecomercial: null,
                idlocal: null,
                foto: null,
                cpfcnpj: null,
                coderp: null,
                idusuariopai: null,
                idorganograma: null, //funcao
            },
            sellerObject: {
                idequipe: null,
                idpolcomissao: null,
                idsalesregion: null,
                idlinha: null,
            },
            representativeObject: {
                idrepresentada: {
                    idrepresentada: ''
                },
                pedidos: '',
                preco: ''
            },
        }, () => this.onUserTableChange(0))
    }

    onUserTableChange = (page) => {
        this.setState({ isLoadingUserTable: true })

        let config = {
            method: 'get',
            endpoint: 'user/table/search'
        }
        let form = {
            page: page,
            name: this.state.name,
            email: this.state.email,
            type: this.state.type,
            status: this.state.status,
            function: this.state.function,
            team: this.state.team,
            superior: this.state.superior
        }
        defaultRequest(config, form).then((r) => {
            if (r.status) {
                this.setState({
                    userList: r.data.user,
                    userColumns: r.data.columns,
                    userTotalSize: r.data.total_size,

                    isLoading: false,
                    isLoadingUserTable: false
                })
            }
        })
    }

    onUserLocalSaleTableChange = async (page) => {
        let config = {
            method: 'get',
            endpoint: 'user/single/localsale',
        }
        let form = {
            page: page,
            id: this.state.selectedRow.idusuario,
        }
        try {
            const r = await defaultRequest(config, form)
            if (r.status) {
                this.setState({
                    userLocalSaleList: r.data.userLocalSaleList,
                    userLocalSaleColumns: r.data.columns,
                    userLocalSaleTotalSize: r.data.total_size,
                }, () => this.handleChangeTab())
            }
        } catch (error) {
            console.error('Erro ao buscar local sale', error)
        }
    }

    onUserSalesRegionTableChange = async (page) => {
        let config = {
            method: 'get',
            endpoint: 'user/single/salesregion',
        }
        let form = {
            page: page,
            id: this.state.selectedRow.idusuario,
        }
        try {
            const r = await defaultRequest(config, form)
            if (r.status) {
                this.setState({
                    userSalesRegionList: r.data.userSalesRegionList,
                    userSalesRegionColumns: r.data.columns,
                    userSalesRegionTotalSize: r.data.total_size,

                    isLoadingUserSalesRegionTable: false,
                }, () => this.handleChangeTab())
            }
        } catch (error) {
            console.error('Erro ao buscar local sale', error)
        }
    }

    onUserLocalSaleTableEdit = (row, method, extraParam) => {
        if (method === 'delete') {
            this.setState({
                userLocalSaleList: row
            }, () => this.deleteUserLocalSale(extraParam))
        }
    }

    onUserSalesRegionTableEdit = (row, method, extraParam) => {
        if (method === 'delete') {
            this.setState({
                userSalesRegionList: row
            }, () => this.deleteUserSalesRegion(extraParam))
        }
    }

    onUserRepresentativeLocalTableEdit = (row, method, extraParam) => {
        if (method === 'edit') {
            this.setState({
                representativeLocalList: row
            }, () => this.handleChangeTab())
        }
    }

    saveUser = () => {
        const user = this.state.userObject

        if (
            !user.nome || 
            !user.sobrenome || 
            !user.email || 
            !user.senha || 
            !user.telcelular || 
            !user.situacao || 
            !user.idlocal || 
            (this.state.userObject.tipousuario === 6 && !this.state.representativeObject?.idrepresentada?.idrepresentada) ||
            (this.state.userObject.tipousuario === 7 && !this.state.userObject?.idrepresentada)
        ) {
            this.setState({
                alertMessage: 'Preencha todos os campos obrigatórios (*)',
                alertType: 'error',
                showAlert: true,

                isLoadingTab: false
            })
            return
        }

        delete user.foto

        user.usarbackoffice = user.usarbackoffice ? 'S' : 'N'
        user.usarorcamento = user.usarorcamento ? 'S' : 'N'

        let config = {
            method: 'post',
            endpoint: 'user/single'
        }
        let form = {
            userObject: user,
            sellerObject: this.state.sellerObject,
            representativeObject: this.state.representativeObject ? {
                idusuario: this.state.selectedRow.idusuario,
                pedidos: this.state.representativeObject.pedidos ? 'S' : 'N',
                preco: this.state.representativeObject.preco ? 'S' : 'N',
                idrepresentada: {
                    ...this.state.representativeObject.idrepresentada,
                    situacao: this.state.representativeObject.idrepresentada.situacao === 'ATIVO' ? 'A' : 'X'
                }
            } : {},
            id: this.state.selectedRow && this.state.selectedRow.idusuario ? this.state.selectedRow.idusuario : null
        }
        defaultRequest(config, form).then((r) => {
            if (r.status) {
                var newState = {
                    alertMessage: r.data.message,
                    alertType: 'success',
                    showAlert: true,

                    isLoadingTab: false
                }

                if (this.state.isANewUser) {
                    newState['isANewUser'] = false
                }

                this.setState(prevState => ({
                    ...prevState, ...newState
                }), () => this.closeEditTab())

            } else {
                this.setState({
                    alertMessage: r.data.message,
                    alertType: 'error',
                    showAlert: true,

                    isLoadingTab: false
                })
            }
        })
    }

    searchSingleUser = async () => {
        let config = {
            method: 'get',
            endpoint: 'user/single',
        }
        let form = {
            id: this.state.selectedRow.idusuario,
        }
        try {
            const r = await defaultRequest(config, form)
            if (r.status) {
                var userObjectNew = r.data.user
                userObjectNew.usarbackoffice = userObjectNew.usarbackoffice === 'S'
                userObjectNew.usarorcamento = userObjectNew.usarorcamento === 'S'
                this.setState({
                    userObject: userObjectNew,
                })
            }
        } catch (error) {
            console.error('Erro ao buscar usuário', error)
        }
    }

    searchSingleUserRepresentative = async () => {
        let config = {
            method: 'get',
            endpoint: 'user/single/representative',
        }
        let form = {
            id: this.state.selectedRow.idusuario,
        }
        try {
            const r = await defaultRequest(config, form)
            if (r.status) {
                var representativeObjectNew = r.data.representativeObject
                representativeObjectNew.pedidos = representativeObjectNew.pedidos === 'S'
                representativeObjectNew.preco = representativeObjectNew.preco === 'S'
                this.setState({
                    representativeObject: representativeObjectNew,
                    representativeRegionList: representativeObjectNew.idrepresentada.regions ?? [],
                    representativeRegionTotalSize: representativeObjectNew.idrepresentada?.regions?.length,

                    representativeLocalList: representativeObjectNew.idrepresentada.local ?? [],
                    representativeLocalTotalSize: representativeObjectNew.idrepresentada?.local?.length,

                    isLoadingUserRepresentative: false,
                    isLoadingUserRepresentativeRegionsTable: false,
                    isLoadingUserRepresentativeLocalTable: false,

                    isUserRepresentativeLoaded: true,
                }, () => this.handleChangeTab())
            } else {
                this.setState({
                    alertMessage: r.data.message,
                    alertType: 'error',
                    showAlert: true,

                    isLoadingUserRepresentative: false,
                    isLoadingUserRepresentativeRegionsTable: false,
                    isLoadingUserRepresentativeLocalTable: false,

                    isUserRepresentativeLoaded: true,
                }, () => this.handleChangeTab())
            }
        } catch (error) {
            console.error('Erro ao buscar representante:', error)
            this.setState({
                alertMessage: 'Erro na requisição',
                alertType: 'error',
                showAlert: true,

                isLoadingUserRepresentative: false,
                isLoadingUserRepresentativeRegionsTable: false,
                isLoadingUserRepresentativeLocalTable: false,

                isUserRepresentativeLoaded: true,
            })
        }
    }

    searchSingleUserSeller = async () => {
        let config = {
            method: 'get',
            endpoint: 'user/single/seller',
        }
        let form = {
            id: this.state.selectedRow.idusuario,
        }
        try {
            const r = await defaultRequest(config, form)
            if (r.status) {
                this.setState({
                    sellerObject: r.data.sellerObject,

                    isLoadingUserSeller: false,
                }, () => this.handleChangeTab())
            }
        } catch (error) {
            console.error('Erro ao buscar superiores', error)
        }
    }

    searchSingleUserSuperior = async () => {
        let config = {
            method: 'get',
            endpoint: 'user/single/superior',
        }
        let form = {
            id: this.state.selectedRow.idusuario,
        }
        try {
            const r = await defaultRequest(config, form)
            if (r.status) {
                this.setState({
                    superiorOptions: r.data.superiorList,
                })
            }
        } catch (error) {
            console.error('Erro ao buscar superiores', error)
        }
    }

    showAlert = (message, type) => {
        this.setState({
            alertMessage: message,
            alertType: type,
            showAlert: true,
        }, () => this.handleChangeTab())
    }

    verifyComissionPolicePopup = () => {
        if (!this.state.sellerObject.idpolcomissao) {
            this.setState({
                alertMessage: 'É necessário selecionar uma Política de Comissão.',
                alertType: 'error',
                showAlert: true
            })
            return
        }
        this.setState({ isUserSalesRegionPopupOpen: true }, () => this.handleChangeTab())
    }

    render() {
        if (this.state.isLoading || this.state.isLoadingOptions) {
            return (
                <LoadingGif />
            )
        }
        return (
            <>
                {this.state.showAlert ? <SnackbarAlert alertType={this.state.alertType} open={true} message={this.state.alertMessage} onClose={() => this.setState({ showAlert: false, alertMessage: '' })} /> : <></>}

                <Box className='outline-box'>
                    <Header {...this.props} title='Usuários' menuId={this.state.menuId} showFav />
                    <Box className='main-box' backgroundColor={this.props.colors.primary[400]}>
                        <MainLabel {...this.props} variant="tabSubTitle" label="Pesquisar Dados" />
                        <Grid container rowSpacing={2} columnSpacing={2}>
                            <Grid item xl={3} lg={3} md={3}>
                                <MainTextField {...this.props} id='name' value={this.state.name} label='Nome' handleChange={this.handleChangeText} width='100%' />
                            </Grid>

                            <Grid item xl={3} lg={3} md={3}>
                                <MainTextField {...this.props} id='email' value={this.state.email} label='Email' handleChange={this.handleChangeText} width='100%' />
                            </Grid>

                            <Grid item xl={3} lg={3} md={3}>
                                <MainSelectInput {...this.props} id='type' value={this.state.type} optionsList={this.state.userTypeOptions} label='Tipo de Usuário' handleChange={this.handleChangeText} width='100%' />
                            </Grid>

                            <Grid item xl={3} lg={3} md={3}>
                                <MainSelectInput {...this.props} id='superior' value={this.state.superior} optionsList={this.state.userNameSurnameOptions} label='Superior' handleChange={this.handleChangeText} width='100%' />
                            </Grid>

                            <Grid item xl={2} lg={2} md={2}>
                                <MainSelectInput {...this.props} id='function' value={this.state.function} optionsList={this.state.userFunctionOptions} label='Função' handleChange={this.handleChangeText} width='100%' />
                            </Grid>

                            <Grid item xl={2} lg={2} md={2}>
                                <MainSelectInput {...this.props} id='team' value={this.state.team} optionsList={this.state.saleTeamOptions} label='Equipe' handleChange={this.handleChangeText} width='100%' />
                            </Grid>

                            <Grid item xl={2} lg={2} md={2}>
                                <MainSelectInput {...this.props} id='status' value={this.state.status} optionsList={this.state.statusOptions} label='Situação' handleChange={this.handleChangeText} width='100%' />
                            </Grid>

                            <Grid item xl={2} lg={2} md={2}>
                                <Button sx={{ background: this.props.colors.custom['searchButtons'], width: '100%', height: '100%' }} {...this.props} variant='contained' onClick={() => this.onUserTableChange(0)}>Buscar</Button>
                            </Grid>
                            <Grid item xl={2} lg={2} md={2}>
                                <Button sx={{ background: this.props.colors.custom['searchButtons'], width: '100%', height: '100%' }} {...this.props} variant='contained' onClick={() => this.setState({
                                    name: '',
                                    email: '',
                                    type: null,
                                    status: null,
                                    function: null,
                                    team: null,
                                    superior: null
                                }, () => this.onUserTableChange(0))}
                                >Limpar</Button>
                            </Grid>
                            <Grid item xl={2} lg={2} md={2}>
                                <Button sx={{ background: this.props.colors.custom['searchButtons'], width: '100%', height: '100%' }} {...this.props} variant='contained' onClick={() => this.setState({ isANewUser: true }, (params) => this.createEditTab(params, true))}>Novo</Button>
                            </Grid>
                        </Grid>
                        <EditableTable
                            {...this.props}
                            id='idusuario'
                            data={this.state.userList}
                            columns={this.state.userColumns}
                            rowId='idusuario'
                            totalSize={this.state.userTotalSize}
                            onPageChange={this.onUserTableChange}
                            onEditRow={() => { }}
                            onRowDoubleClick={(params) => this.createEditTab(params, false)}
                            isLoading={this.state.isLoadingUserTable}
                            extraColumnsConfig={
                                {
                                    'idusuario': {
                                        'type': 'number'
                                    },
                                    'situacao': {
                                        'type': 'select',
                                        'options': this.state.statusOptions
                                    },
                                    'idusuariopai': {
                                        'type': 'select',
                                        'options': this.state.userNameSurnameOptions
                                    },
                                    'idorganograma': {
                                        'type': 'select',
                                        'options': this.state.userFunctionOptions
                                    },
                                }
                            }
                        />
                    </Box>
                </Box>
            </>
        )
    }
}

export default User;